import React from 'react';
import Button from '../../Button';
import s from './attendance.module.css';

// One of the attendance drawer's three send buttons (#732): Email Lesson
// Notes, Email Receipt and Send Cancellation Notice. Each saves the drawer and
// then queues its one message; Save itself sends nothing. Why, and where that
// differs from MMS, is in src/hooks/useAttendanceForm.js and at
// `attendance_send_state` in core/src/messages.rs.
//
// `send` is the hook's `sends.<kind>`: the label (Sent once it has gone),
// whether it is offered, whether its save is running, and the line under it.
// A disabled button does not say why — no button on this drawer does, and
// the controls above it already say what is missing ("No email address on
// this family", nothing ticked, no amount).
export default function SendButton({ send, onSend }) {
  if (!send) return null;
  return (
    <div className={s.sendRow}>
      <Button
        variant="secondary"
        size="sm"
        disabled={!send.enabled}
        loading={send.sending}
        onClick={onSend}
      >
        {send.label}
      </Button>
      {send.line ? <span className={s.sendLine} role="status">{send.line}</span> : null}
    </div>
  );
}
